import { ListData } from "../types/List";
import { workflowApiUrl } from "./api";

const API_URL = "/Statuses";

export const getData = async (): Promise<ListData[]> => {
  try {
    const res = await workflowApiUrl.get<ListData[]>(API_URL);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all statuses error: ${
        error.response?.data?.message || error.message
      }`
    );
    return []; // Return empty array on error
  }
};

export const getDataById = async (id: number): Promise<ListData | null> => {
  try {
    const res = await workflowApiUrl.get<ListData>(`${API_URL}/${id}`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get status error: ${error.response?.data?.message || error.message}`
    );
    return null; // Return null on error
  }
};
